// Get the URL parameters
const urlParams = new URLSearchParams(window.location.search);
const pagesubmissionLink = "/pages/subscription-boxes?view=subscription-boxes";

// Check if 'bxstep' parameter exists
if (urlParams.has('bxstep')) {
  const step = urlParams.get('bxstep');

 if (step === '2') {
    const stepSelection = document.querySelector('.sbrp_step-section.sbrp_step-tier');
    stepSelection.classList.add("active");
    sub_boxes_step2_fun(stepSelection);
  } else if (step === '3') {
    var subscriptionData = {};

    const stepSelection = document.querySelector('.sbrp_step-section.sbrp_step-checkout');
    stepSelection.classList.add("active");
    sub_boxes_step3_fun(stepSelection);
  } else {
    const stepSelection = document.querySelector('.sbrp_step-section.sbrp_step-details');
    stepSelection.classList.add("active");
    sub_boxes_step1_fun(stepSelection);
  }
} else {
  const stepSelection = document.querySelector('.sbrp_step-section.sbrp_step-details');
  stepSelection.classList.add("active");
  sub_boxes_step1_fun(stepSelection);
}


function sub_boxes_step1_fun(stepSelection){
    // Handle form submission
    document.getElementById('detailsForm').addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Collect form data
        const formData = {
            hatStyle: document.querySelector('input[name="hatStyle"]:checked').value,
            shirtSize: document.getElementById('shirtSize').value,
            waistSize: document.getElementById('waistSize').value,
            jacketSize: document.getElementById('jacketSize').value,
            gloveHand: document.querySelector('input[name="gloveHand"]:checked').value,
            gloveSize: document.getElementById('gloveSize').value,
            golfStyle: document.getElementById('golfStyle').value
        };
        
        // Store data in localStorage
        localStorage.setItem('subscriptionDetails', JSON.stringify(formData));
        
        // Redirect to tier selection
        window.location.href = pagesubmissionLink + '&bxstep=2';
    });
}

function sub_boxes_step2_fun(stepSelection){
    let selectedTier = null;
        
      
        // Check if user came from details page
        window.addEventListener('load', function() {
            const details = localStorage.getItem('subscriptionDetails');
            if (!details) {
                // Redirect back to details if no data
                window.location.href = pagesubmissionLink;
            }
            
            // Initialize GIF hover functionality
            initializeGifHover();
        });
         
}

function sub_boxes_step3_fun(stepSelection){

    // Load subscription data on page load
    window.addEventListener('load', function() {
        const data = localStorage.getItem('subscriptionDetails');
        if (!data) {
            alert('Please start from the beginning and fill out your details.');
            window.location.href = pagesubmissionLink;
            return;
        }
        
        subscriptionData = JSON.parse(data);
        populateSummary();
    });

}



// all functions



     function selectTierCard(card) {
            // Remove selection from all cards
            document.querySelectorAll('.sbrp_tier-card').forEach(c => {
                c.classList.remove('selected');
            });
            
            // Add selection to clicked card
            card.classList.add('selected');
            
            // Store selected tier info
          selectedTier = {
                tier: card.dataset.variant
            };
            // Show continue button
            document.getElementById('continueSection').style.display = 'block';
        }
        
        // Keep the old function for backwards compatibility (in case it's used elsewhere)
        function selectTier(button) {
            const card = button.closest('.sbrp_tier-card');
            selectTierCard(card);
        }
        
        function continueToCheckout() {
            if (!selectedTier) {
                alert('Please select a tier first.');
                return;
            }
            
            // Get existing details from localStorage
            const existingDetails = JSON.parse(localStorage.getItem('subscriptionDetails') || '{}');
            
            // Add tier selection
            const completeData = {
                ...existingDetails,
                ...selectedTier
            };
            
            // Store complete data
            localStorage.setItem('subscriptionDetails', JSON.stringify(completeData));
            
            // Redirect to review page
            window.location.href = pagesubmissionLink + '&bxstep=3';
        }
        
        function initializeGifHover() {
            const tierCards = document.querySelectorAll('.sbrp_tier-card');
            
            tierCards.forEach(card => {
                const canvas = card.querySelector('.sbrp_tier-static');
                const gifImg = card.querySelector('.sbrp_tier-gif');
                const gifSrc = canvas.getAttribute('data-gif');
                
                // Create static image from first frame
                createStaticImage(canvas, gifSrc);
                
                // Add hover events
                card.addEventListener('mouseenter', () => {
                    playGif(canvas, gifImg, gifSrc);
                });
                
                card.addEventListener('mouseleave', () => {
                    pauseGif(canvas, gifImg);
                });
            });
        }
        
        function createStaticImage(canvas, gifSrc) {
            const ctx = canvas.getContext('2d');
            const img = new Image();
            
            img.onload = function() {
                // Set canvas dimensions to match container
                const container = canvas.parentElement;
                canvas.width = container.clientWidth;
                canvas.height = container.clientHeight;
                
                // Draw the first frame
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            };
            
            img.src = gifSrc;
        }
        
        function playGif(canvas, gifImg, gifSrc) {
            // Hide static canvas, show animated GIF
            canvas.style.opacity = '0';
            gifImg.style.display = 'block';
            gifImg.style.opacity = '1';
            
            // Force GIF to restart by changing src
            gifImg.src = gifSrc + '?t=' + Date.now();
        }
        
        function pauseGif(canvas, gifImg) {
            // Show static canvas, hide animated GIF
            canvas.style.opacity = '1';
            gifImg.style.opacity = '0';
            
            // After transition, hide the GIF completely
            setTimeout(() => {
                if (gifImg.style.opacity === '0') {
                    gifImg.style.display = 'none';
                }
            }, 300);
        }
function populateSummary() {
      
         const productCard = document.querySelector(`.sbrp_tier-card[data-variant="${subscriptionData.tier}"]`);
         const productTitle = productCard.querySelector(`.sbrp_tier-name`).textContent;
         const productImage = productCard.querySelector(`.sbrp_tier-gif`).getAttribute("src");
         const productPrice = productCard.querySelector(`.sbrp_tier-price`).textContent;
        document.querySelector(`.sbrp_next_bill_time`).textContent = getNextQuarterMonthYear(3);

        // Populate tier summary
        const tierSummary = document.getElementById('tierSummary');
        tierSummary.innerHTML = `
            <div class="sbrp_tier-preview">
                <div class="sbrp_tier-preview-image">
                    <img src="${productImage}" alt="${productTitle}" />
                </div>
                <h3 style="color: var(--accent-green); font-size: 1.5rem; margin-bottom: 8px;">${productTitle}</h3>
                <div style="font-size: 2rem; font-weight: 700;">${productPrice}</div>
                <div style="opacity: 0.7; font-size: 14px;">per quarter</div>
            </div>
        `;
        
        // Populate preferences summary
        const preferencesSummary = document.getElementById('preferencesSummary');
        preferencesSummary.innerHTML = `
            <div class="sbrp_preferences-grid">
                <div class="sbrp_preference-item">
                    <div class="sbrp_preference-label">Hat Style</div>
                    <div class="sbrp_preference-value">${subscriptionData.hatStyle === 'flat' ? 'Flat Bill' : 'Curved'}</div>
                </div>
                <div class="sbrp_preference-item">
                    <div class="sbrp_preference-label">Shirt Size</div>
                    <div class="sbrp_preference-value">${subscriptionData.shirtSize}</div>
                </div>
                <div class="sbrp_preference-item">
                    <div class="sbrp_preference-label">Waist Size</div>
                    <div class="sbrp_preference-value">${subscriptionData.waistSize}</div>
                </div>
                <div class="sbrp_preference-item">
                    <div class="sbrp_preference-label">Jacket Size</div>
                    <div class="sbrp_preference-value">${subscriptionData.jacketSize}</div>
                </div>
                <div class="sbrp_preference-item">
                    <div class="sbrp_preference-label">Glove</div>
                    <div class="sbrp_preference-value">${subscriptionData.gloveHand === 'left' ? 'Left Hand' : 'Right Hand'} / ${subscriptionData.gloveSize}</div>
                </div>

                 <div class="sbrp_preference-item">
                    <div class="sbrp_preference-label">My Style</div>
                    <div class="sbrp_preference-value">${subscriptionData.golfStyle}</div>
                </div>
                
            </div>
        `;
        
        // Populate pricing
        document.getElementById('subtotal').textContent = `${productPrice}`;
        document.getElementById('total').textContent = `${productPrice}`;
        
        // Populate overview sections
        populateOverview();
    }

    function populateOverview() {
        const productCard = document.querySelector(`.sbrp_tier-card[data-variant="${subscriptionData.tier}"]`);
         const productTitle = productCard.querySelector(`.sbrp_tier-name`).textContent;
         const productImage = productCard.querySelector(`.sbrp_tier-gif`).getAttribute("src");
         const productPrice = productCard.querySelector(`.sbrp_tier-price`).textContent;
        // Hide customer info section since we don't collect it anymore
        const customerInfo = document.getElementById('customerInfo');
        if (customerInfo) {
            customerInfo.style.display = 'none';
        }
        
        // Populate preferences overview
        const preferencesOverview = document.getElementById('preferencesOverview');
        preferencesOverview.innerHTML = `
            <div class="sbrp_pref-item">
                <div class="sbrp_pref-label">Hat Style</div>
                <div class="sbrp_pref-value">${subscriptionData.hatStyle === 'flat' ? 'Flat Bill' : 'Curved'}</div>
            </div>
            <div class="sbrp_pref-item">
                <div class="sbrp_pref-label">Shirt Size</div>
                <div class="sbrp_pref-value">${subscriptionData.shirtSize}</div>
            </div>

             <div class="sbrp_pref-item">
                <div class="sbrp_pref-label">Waist Size</div>
                <div class="sbrp_pref-value">${subscriptionData.waistSize}</div>
            </div>

            <div class="sbrp_pref-item">
                <div class="sbrp_pref-label">Jacket Size</div>
                <div class="sbrp_pref-value">${subscriptionData.jacketSize}</div>
            </div>
            <div class="sbrp_pref-item">
                <div class="sbrp_pref-label">Glove Preferences</div>
                <div class="sbrp_pref-value">${subscriptionData.gloveHand === 'left' ? 'Left Hand' : 'Right Hand'} / ${subscriptionData.gloveSize}</div>
            </div>

            <div class="sbrp_pref-item">
                <div class="sbrp_pref-label">My Style</div>
                <div class="sbrp_pref-value">${subscriptionData.golfStyle}</div>
            </div>
        `;
        
        // Populate subscription overview
        const subscriptionOverview = document.getElementById('subscriptionOverview');
        subscriptionOverview.innerHTML = `
            <div class="sbrp_info-row">
                <span class="sbrp_info-label">Subscription Tier</span>
                <span class="sbrp_info-value">${productTitle}</span>
            </div>
            <div class="sbrp_info-row">
                <span class="sbrp_info-label">Billing Frequency</span>
                <span class="sbrp_info-value">Quarterly (Every 3 months)</span>
            </div>
            <div class="sbrp_info-row">
                <span class="sbrp_info-label">Price per Quarter</span>
                <span class="sbrp_info-value">${productPrice}</span>
            </div>
        `;
    }

    function addToCart() {
        // Add to cart only - stays on current page
        addToShopifyCart(false);
    }

    function checkoutNow() {
        // Add to cart and redirect to checkout
        addToShopifyCart(true);
    }
  function getNextQuarterMonthYear(nextmonth) {
    const now = new Date();

    // Add the number of months to the current month
    const futureDate = new Date(now.getFullYear(), now.getMonth() + nextmonth, 1);

    // Array of month names
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Get the resulting month name and year
    const monthName = monthNames[futureDate.getMonth()];
    const year = futureDate.getFullYear();

    return `${monthName} ${year}`;
}




    function addToShopifyCart(redirectToCheckout = true) {
        const productCard = document.querySelector(`.sbrp_tier-card[data-variant="${subscriptionData.tier}"]`);

        
        const variantId = productCard.dataset.variant;
        const selling_plan = productCard.dataset.sellingplanid;
        
        // Create properties for Shopify line item
        const properties = {
            'Hat Style': subscriptionData.hatStyle === 'flat' ? 'Flat Bill' : 'Curved',
            'Shirt Size': subscriptionData.shirtSize,
            'Waist Size': subscriptionData.waistSize,
            'Jacket Size': subscriptionData.jacketSize,
            'Glove Hand': subscriptionData.gloveHand === 'left' ? 'Left Hand' : 'Right Hand',
            'Glove Size': subscriptionData.gloveSize,
            'Subscription Type': 'Quarterly',
            'Next Ship Date': getNextQuarterMonthYear(3)
        };
        
        // Add to Shopify cart using Ajax API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                selling_plan: selling_plan,
                properties: properties
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Added to Shopify cart:', data);
            
            if (redirectToCheckout) {
                // Clear localStorage and redirect to checkout
                localStorage.removeItem('subscriptionDetails');
                window.location.href = '/checkout';
            } else {
                // Just show success message, stay on page
                alert('Successfully added to cart!');
                localStorage.removeItem('subscriptionDetails');
                window.location.href = '/cart';
    
                // Optionally update cart counter in navigation
                // updateCartCounter();
            }
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            
            // Fallback: Create a product form and submit it
           // createShopifyProductForm(redirectToCheckout);
        });
    }

    